import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-assign-status',
  templateUrl: './assign-status.component.html',
  styleUrls: ['./assign-status.component.scss']
})
export class AssignStatusComponent implements OnInit {
  @Input() step = null;
  @Output() radioChangEmitter = new EventEmitter<object>();
  radioValue = "agree";
  rejectRemarkText = "";
  agreeRemarkText = "";

  ngOnInit(): void {
    this.radioChangEmitter.emit({ 'status': 1, 'remark': null });
  }
  nzRadioChang(checked: string) {
    this.radioValue = checked;
    if (checked === "reject") {
      this.radioChangEmitter.emit({ 'status': 2, 'remark': null });
    } else {
      this.radioChangEmitter.emit({ 'status': 1, 'remark': null });
    }
  }

  nzInputChang(value: string, radioValue: string) {
    if (radioValue === 'agree') {
      this.agreeRemarkText = value;
      this.radioChangEmitter.emit({ 'status': 1, 'remark': this.agreeRemarkText });
    }
    else {
      this.rejectRemarkText = value;
      this.radioChangEmitter.emit({ 'status': 2, 'remark': this.rejectRemarkText });
    }
  }
}
